import { createContext } from 'react';
import { Level } from '@/types/Level';

type SchoolContext = {
  id: number | null;
  schema: string;
  slug: string;
  db: string;
  tenant_id: string;
  levels?: Level[] | null;
  is_tournament_contract: boolean;
  is_school_contract: boolean;
  is_rental_contract: boolean;
};

const SchoolContext = createContext<SchoolContext>({
  id: null,
  schema: '',
  slug: '',
  db: '',
  tenant_id: '',
  levels: null,
  is_tournament_contract: false,
  is_school_contract: false,
  is_rental_contract: false,
});

export default SchoolContext;
